var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin_panel__dashboard__menu"},[_vm._l((_vm.data),function(item){return _c('AdminPanelDashboardMenuItem',{key:item.path,attrs:{"item":item}})}),_c('AdminPanelDashboardMenuItem',{attrs:{"item":{ text: 'Exit' },"action":_vm.logOut}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }